import { render, staticRenderFns } from "./AdvancedSettings.vue?vue&type=template&id=9ec36ff4&scoped=true&"
import script from "./AdvancedSettings.vue?vue&type=script&lang=js&"
export * from "./AdvancedSettings.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedSettings.vue?vue&type=style&index=0&id=9ec36ff4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec36ff4",
  null
  
)

export default component.exports